/* eslint camelcase: 0 */
import moment from 'moment'
import { Recruitment } from '@/infrastructure/network/Upstream/schema'
import { IRecruitmentProps, EmptyRecruitmentPropsFactory } from '@/entities/Upstream/Recruitment'

export const toRecruitmentProps = (props: Recruitment | null | undefined): IRecruitmentProps => {
  if (!props) {
    return EmptyRecruitmentPropsFactory()
  }

  const { id, opened_at, closed_at, created_at, updated_at } = props

  const safeParse = <T>(str: string | null, key: string, fallback: T): T => {
    if (!str) return fallback
    try {
      return JSON.parse(str)[key] ?? fallback
    } catch {
      return fallback
    }
  }

  const defaults = EmptyRecruitmentPropsFactory()
  const title = safeParse(props.title, 'title', defaults.title)
  const description = safeParse(props.description, 'description', defaults.description)
  const properties = safeParse(props.properties, 'properties', defaults.properties)
  const media = safeParse(props.media, 'media', defaults.media)

  return EmptyRecruitmentPropsFactory({
    id,
    title,
    description,
    properties,
    media,
    openedAt: opened_at ? moment(opened_at).format('YYYY-MM-DD HH:mm:ss') : null,
    closedAt: closed_at ? moment(closed_at).format('YYYY-MM-DD HH:mm:ss') : null,
    createdAt: created_at ? moment(created_at).format('YYYY-MM-DD HH:mm:ss') : null,
    updatedAt: updated_at ? moment(updated_at).format('YYYY-MM-DD HH:mm:ss') : null
  })
}
